const CUSTOMER_ID_PATTERN = /\d{6,15}(?!\d)/g;
const EMAIL_PATTERN = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi;

/**
 * Finds identifiers which can be copied with one short activation. An ID must
 * be a standalone 6-to-15-digit sequence, not a portion of another word,
 * address, or longer number.
 */
export const findCustomerIdTargets = text => {
  const source = String(text ?? '');

  return [...source.matchAll(CUSTOMER_ID_PATTERN)]
    .filter(match => {
      const previous = match.index > 0 ? source[match.index - 1] : '';
      const next = source[match.index + match[0].length] || '';
      return !/[A-Za-z0-9_@]/.test(previous) && !/[A-Za-z0-9_@]/.test(next);
    })
    .map(match => ({ index: match.index, value: match[0] }));
};

export const findMessageCopyTargets = text => {
  const source = String(text ?? '');
  const identifiers = findCustomerIdTargets(source);
  const emails = [...source.matchAll(EMAIL_PATTERN)].map(match => ({
    index: match.index,
    value: match[0],
  }));

  return [...identifiers, ...emails].sort((left, right) => left.index - right.index);
};
